import React from 'react';
import { styled, type TextProps, YStack, type YStackProps } from 'tamagui';

import type { ColorTokenKey } from '../../themes/SmoothieColorTokens';
import { Icon, type IconType } from '../icons/Icon';
import { LabelEmphasized } from '../text/Typography';

const BaseTileButton = styled(YStack, {
    backgroundColor: '$gray100',
    borderRadius: 12,
    flex: 1,
    gap: 4,
    animation: 'quick',
    alignItems: 'center',
    justifyContent: 'center',
});

interface TileButtonProps {
    text?: string;
    icon?: IconType;
    onPress: () => void;
    tileProps?: YStackProps;
    textProps?: TextProps;
    color?: ColorTokenKey;
}

// TODO DESIGN: consolidate the various icon props into a single iconProps object with a type of Props from Icon
export const TileButton = ({
    text,
    icon,
    onPress,
    tileProps,
    color,
    textProps,
}: TileButtonProps) => {
    const { disabled } = tileProps ?? {};
    color = disabled ? '$gray800' : (color ?? '$black');
    return (
        <BaseTileButton
            key={`text-${disabled}`} // works around this issue: https://github.com/tamagui/tamagui/issues/3055
            flex={1}
            flexBasis={0}
            onPress={onPress}
            pressStyle={{
                scale: 0.98,
            }}
            backgroundColor={disabled ? '$gray100' : '$gray200'}
            disabled={disabled}
            cursor={disabled ? 'not-allowed' : 'pointer'}
            {...tileProps}
        >
            {icon && <Icon icon={icon} color={color} size={18} />}
            {text !== undefined && text !== '' && (
                <LabelEmphasized {...textProps} color={color}>
                    {text}
                </LabelEmphasized>
            )}
        </BaseTileButton>
    );
};
